/* tslint:disable */
/* eslint-disable */
export enum PersonNameType {
  LEGAL = 'LEGAL'
}
